module.exports = __webpack_public_path__ + "img/1159.3a3f6070.gif";